import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ContentSlider from '../../ContentSlider/ContentSlider';
import './css/style.scss';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { getCertificateSessions } from '../../../Store/actions/automatedCta.action';
import { SessionCardLoader } from '../../../skeleton/session';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
SwiperCore.use([Pagination, Navigation]);
function CtaCardV14({ data, onClickCallback }) {
  const { pathname, search } = useLocation();
  const { id } = queryString.parse(search);
  const dispatch = useDispatch();
  const [session_data, setSessions] = useState([]);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    dispatch(
      getCertificateSessions((res) => {
        if (res?.length > 0) {
          setSessions(res);
          setLoader(false);
        }
      })
    );
  }, []);
  const ContentSliderLoader = (isCta = false) => {
    return (
      <div className="w-100 cmnLandingSlideRow mt-4">
        <div className="cmnLndngRowSlidePrrnt">
          <Swiper
            className="cmnLndngRowSlide"
            spaceBetween={24}
            slidesPerView={3}
            loop={false}
            breakpoints={{
              1: {
                slidesPerView: 1,
                spaceBetween: 10
              },
              640: {
                slidesPerView: isCta ? 2 : 3,
                spaceBetween: 15
              },
              768: {
                slidesPerView: isCta ? 1 : 2,
                spaceBetween: 22
              },
              992: {
                slidesPerView: isCta ? 1 : 3,
                spaceBetween: 24
              },
              1400: {
                slidesPerView: isCta ? 2 : 4, //4
                spaceBetween: 26
              }
            }}
          >
            {[...Array(6).keys()].map((_video, index) => (
              <SwiperSlide key={index + 1}>
                <SessionCardLoader />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    );
  };
  return (
    <div className="w-100 ctaCardV14Box position-relative overflow-hidden bg-white shadow p-3 p-md-4 p-lg-5 rounded-3 mb-4">
      <div className="ctaCardBoxIn text-start">
        <h4 className="fs-3 text-primary fw-medium mb-3">
          Interested in earning more certificates in {data?.session?.speciality ?? ''}?
        </h4>
        <h6 className="fs-4 fw-medium text-black mb-4">
          Please find below the list of sessions with certificate
        </h6>
        <div className="w-100">
          {!loader ? (
            <ContentSlider
              isCta
              contentArray={session_data}
              type="session"
              clickCallback={(sessionId) => {
                console.log('SESSION_ID', sessionId);
                onClickCallback(
                  data?.id,
                  data?.cta_type_id,
                  data?.entity_id,
                  data?.certificate_id,
                  0,
                  pathname,
                  id
                );
              }}
            />
          ) : (
            <ContentSliderLoader isCta />
          )}
        </div>
      </div>
    </div>
  );
}

export default CtaCardV14;
// 'certificate',
//   'session_certificate',
//   data?.session?.session_id ?? 0,
//   {
//     certificate_id: data?.certificate_id
//   };
